// Replace spaces and underscores with hyphens
export const slugify = (str: string) => str.toLowerCase().replace(/[\s_]+/g, '-')

export const sanitizeTitle = (title: string) => title.replace("\\'", "'")

export const getUrlFromTitleId = (title: string, id: string) => {
  const sanitizedTitle = title ? sanitizeTitle(title) : ''
  return `${encodeURIComponent(`${sanitizedTitle ? slugify(sanitizedTitle) : ''}-${id}`)}`
}
